export default "__VITE_ASSET__CJw5Pvz___"